import axios from 'axios'
import * as Config from '@/config.js'

const backend = axios.create({
  baseURL: Config.server.backend
})

export default {
  // user api
  listPublicCwd (walkedPath) {
    return backend.post('/paths/lsPublicCwd', walkedPath)
  },

  langsList(){
    return backend.post('/langs/list')
  }
}



// WEBPACK FOOTER //
// ./src/services/Api.js